// In-page links (#reviews, #facts, #ask, #atc ...) scroll smoothly without adding "#..." to the URL
// (David 29.9.2026). #atc goes to the main buy box. A hash already in the URL on load is cleaned up.
const ALIASES = { atc: 'sm-main-atc' };
const target = (id) => document.getElementById(ALIASES[id] || id);
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a || e.defaultPrevented) return;
  const id = a.getAttribute('href').slice(1);
  if (!id) { e.preventDefault(); return; }
  const el = target(id);
  if (!el) return;
  e.preventDefault();
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
if (location.hash && !/sm-force|shopify/i.test(location.hash)) {
  const el = target(location.hash.slice(1));
  if (el) requestAnimationFrame(() => el.scrollIntoView({ block: 'start' }));
  history.replaceState(null, '', location.pathname + location.search);
}

// Whole product / system cards are clickable (David 29.9.2026): a click anywhere on the card that is not
// on a button, link, input or form control opens the card's product link. Cmd/Ctrl-click opens a new tab.
const CARD = '.sm-card, .sm-sysp__card, .sm-stacks-grid__card, .sm-routine-cta__card';
const LINK = '.sm-card__title, .sm-sysp__title, a[href*="/products/"]';
document.addEventListener('click', (e) => {
  if (e.defaultPrevented || e.button !== 0) return;
  const card = e.target.closest(CARD);
  if (!card || e.target.closest('a, button, input, select, label, textarea, summary, form')) return;
  const link = card.querySelector(LINK);
  if (!link) return;
  if (e.metaKey || e.ctrlKey) window.open(link.href, '_blank');
  else location.href = link.href;
});
